module.exports = __webpack_public_path__ + "img/artboard17.13a0f087.png";